// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import { useSizing } from "../helpers/use-sizing"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"

interface Props
  extends React.ImgHTMLAttributes<HTMLImageElement>,
    PrimitiveBaseProps<HTMLImageElement>,
    PrimitiveWithSizing {}

export function Image(props: Props) {
  const {
    className,
    innerRef,
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)
  return (
    <img
      {...otherProps}
      className={classNames(resetStyles.reset, className, sizingClassName)}
      data-node-id={dataNodeId}
      ref={innerRef}
    />
  )
}
